export enum SwapRouteVariant {
  CURRENT = 'current',
  INITIAL = 'initial',
}
